import { atom, DefaultValue, selector, useRecoilValue } from "recoil";
import { IHolidayRow, IMsFormFilter, IMsRow } from "./types";
import { useMemo } from "react";

export const msHolidayState = atom({
    key: 'msHoliday',
    default: {
        formInEditMode: false,
        holidays: [] as IHolidayRow[],
        mobilityStoresFilters: null as IMsFormFilter | null,
        mobilityStores: [] as IMsRow[],
    }
})

export const formInEditModeState = selector<boolean>({
    key: 'formInEditModeState',
    get: ({ get }) => get(msHolidayState).formInEditMode,
    set: ({ get, set }, newValue) => {
        set(msHolidayState, {
            ...get(msHolidayState),
            formInEditMode: newValue instanceof DefaultValue
                ? get(msHolidayState).formInEditMode
                : newValue
        })
    }
})

export const holidaysState = selector<IHolidayRow[]>({
    key: 'holidaysState',
    get: ({ get }) => get(msHolidayState).holidays,
    set: ({ get, set }, newValue) => {
        set(msHolidayState, {
            ...get(msHolidayState),
            holidays: newValue instanceof DefaultValue
                ? get(msHolidayState).holidays
                : newValue
        })
    }
})

export const useHolidayRow = (id: number) => {
    const rowData = useRecoilValue(holidaysState);
    return useMemo(() => {
        return rowData.find((row) => row.id === id);
    }, [id, rowData]);
}

export const mobilityStoresFiltersState = selector<IMsFormFilter | null>({
    key: 'mobilityStoresFiltersState',
    get: ({ get }) => get(msHolidayState).mobilityStoresFilters,
    set: ({ get, set }, newValue) => {
        set(msHolidayState, {
            ...get(msHolidayState),
            mobilityStoresFilters: newValue instanceof DefaultValue
                ? get(msHolidayState).mobilityStoresFilters
                : newValue
        })
    }
})

export const mobilityStoresState = selector<IMsRow[]>({
    key: 'mobilityStoresState',
    get: ({ get }) => get(msHolidayState).mobilityStores,
    set: ({ get, set }, newValue) => {
        set(msHolidayState, {
            ...get(msHolidayState),
            mobilityStores: newValue instanceof DefaultValue
                ? get(msHolidayState).mobilityStores
                : newValue
        })
    }
})

export const useMsRow = (id: number) => {
    const rowData = useRecoilValue(mobilityStoresState);
    return useMemo(() => {
        return rowData.find((row) => row.id === id);
    }, [id, rowData]);
}
